var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.justMobileClass + 'car-info'},[_c('img',{staticClass:"car-image",attrs:{"src":_vm.carImage,"alt":"car image"}}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.carPlate))]),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.carName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }